import Nullstack from 'nullstack';
export default function IconZoomInArea({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-zoom-in-area",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M15 13v4"
  }), "   ", Nullstack.element("path", {
    d: "M13 15h4"
  }), "   ", Nullstack.element("circle", {
    cx: "15",
    cy: "15",
    r: "5"
  }), "   ", Nullstack.element("path", {
    d: "M22 22l-3 -3"
  }), "   ", Nullstack.element("path", {
    d: "M6 18h-1a2 2 0 0 1 -2 -2v-1"
  }), "   ", Nullstack.element("path", {
    d: "M3 11v-1"
  }), "   ", Nullstack.element("path", {
    d: "M3 6v-1a2 2 0 0 1 2 -2h1"
  }), "   ", Nullstack.element("path", {
    d: "M10 3h1"
  }), "   ", Nullstack.element("path", {
    d: "M15 3h1a2 2 0 0 1 2 2v1"
  }), " ");
}